import { z } from 'zod';

export const RecognizePlateFromImageBodySchema = z.object({
  imageBase64: z.string().trim().min(1).max(5_000_000),
  mimeType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
});

export type RecognizePlateFromImageBody = z.infer<typeof RecognizePlateFromImageBodySchema>;

export const RecognizePlateFromImageResponseSchema = z.object({
  plate: z.string().nullable(),
});

export type RecognizePlateFromImageResponse = z.infer<typeof RecognizePlateFromImageResponseSchema>;
